import DiffMatchPatch from 'diff-match-patch';

export const getTextsDiff = (origText, updatedText) => {
  const dmp = new DiffMatchPatch();
  return dmp.diff_main(origText, updatedText);
};
